import { Injectable } from '@angular/core';
import { Project } from './project'
import { DbRecordService } from './db-record.service'
import { FilterService } from './filter.service'
import { PatentService } from './patent.service'
import { TagService } from './tag.service'

@Injectable()
export class RuntimeService {
  private _adminType
  private _currentProject: Project
  tags: TagService

  constructor(
    private dbrs: DbRecordService,
    private fs: FilterService,
    private ps: PatentService
  ) {
    this.dbrs.rts = this
    this.ps.rts = this
    this.fs.rts = this
  }

  get noTags() {
    return this.tags.noTags
  }

  set adminType(tp: string) {
    this._adminType = tp
  }

  resetAdminType() {
    this._adminType = null
  }

  evalAdminType(tag: string) {
    return tag == this._adminType
  }

  get currentProject() {
    return this._currentProject
  }

  set currentProject(project: Project) {
    this.fs.clear()
    this._currentProject = project
    if (project) {
      this.dbrs.initProjectData(project)
      localStorage.setItem('currentProject', project.id)
    } else
      localStorage.removeItem('currentProject')

  }

  resetCurrentProject() {
    this.currentProject = null
  }


}



// WEBPACK FOOTER //
// ./src/app/runtime.service.ts